export default __webpack_public_path__ + "static/media/prize1.419b6983.svg";